import classNames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";
import {
  Action,
  Heading7,
  Icon,
  ImageLite,
  ModalWrapper,
  Paragraph,
  YoutubeVideo,
} from "shared/components";
import { useLazyRenderingState } from "shared/components/LazyRenderingButton";
import { useViewMode } from "shared/contexts/ViewMode";
import { parseYouTubeId } from "shared/utils";

import styles from "./StudentsList.module.scss";

export const StudentsList = ({ students }) => {
  const { limit } = useLazyRenderingState();
  const [currentVideo, setCurrentVideo] = useState(null);
  const { push } = useRouter();
  const { isDesktop } = useViewMode();

  const slicedStudents = useMemo(() => {
    return students.slice(0, limit);
  }, [limit, students]);

  const selectVideo = useCallback(
    (link) => () => {
      const video = parseYouTubeId(link);

      if (video) {
        setCurrentVideo(video);
        return;
      }
      if (link) {
        push(link);
      }
    },
    [push]
  );

  const clearVideo = useCallback(() => {
    setCurrentVideo(null);
  }, []);

  return (
    <>
      <div className={styles.items}>
        {slicedStudents.map((item) => {
          const video = parseYouTubeId(item.videoLink);

          return (
            <Action
              key={item.id}
              onClick={selectVideo(item.videoLink)}
              className={classNames(styles.item, {
                [styles["non-pointer"]]: !item.videoLink,
              })}
            >
              <div>
                <ImageLite image={item.photo} className={styles.image} />
                <div className={styles.content}>
                  <Heading7 color="light" className={styles.title}>
                    {item.title}
                  </Heading7>
                  {isDesktop && (
                    <div className={styles.bottom}>
                      {video && (
                        <div className={styles.button}>
                          <Icon name="play" theme="accent" />
                        </div>
                      )}
                      <div className={styles.text}>
                        <Paragraph
                          color="light"
                          appearance="bold"
                          className={styles.name}
                        >
                          {item.fullName}
                        </Paragraph>
                        <Paragraph
                          color="light"
                          uppercase
                          className={styles.position}
                        >
                          {item.position}
                        </Paragraph>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Action>
          );
        })}
      </div>

      {currentVideo && (
        <ModalWrapper onCloseModal={clearVideo} appearance="full-area">
          <YoutubeVideo id={currentVideo} />
        </ModalWrapper>
      )}
    </>
  );
};
